// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-width-background{margin-left:calc(-50vw - -720px);margin-right:calc(-50vw - -720px)}.product-details__campaign-circles{display:none}@media screen and (min-width:960px){.product-details__campaign-circles{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
